<template>
  <section id="request" style="background-color: rgba(229,243,252,0.5); " class="pt-10">
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9">
            <div class="text-center mt-4">
              <h1 class="section-title font-weight-light">Заказать услугу</h1>
              <h4 v-if="rateDescription" class="section-subtitle font-weight-light">{{ rateDescription }}</h4>
            </div>
          </v-col>
          <v-col cols="12" md="9" xl="9" class="mb-6 section1-cards" style="padding-left: 0; padding-right: 0;">
            <v-row>
              <v-col cols="12" offset-md="3" md="6" xs="12">
                <v-form ref="form" class="pa-4" @submit.prevent="handleSubmit">
                  <v-select
                      v-model="form.situation"
                      :items="situationItems"
                      label="Ситуация"
                      :error-messages="situationErrors"
                      @input="$v.form.situation.$touch()"
                      @blur="$v.form.situation.$touch()"
                  ></v-select>
                  <!--                  <v-select-->
                  <!--                      v-model="form.rate"-->
                  <!--                      :items="rateItems"-->
                  <!--                      label="Тариф"-->
                  <!--                      :error-messages="rateErrors"-->
                  <!--                      @input="$v.form.rate.$touch()"-->
                  <!--                      @blur="$v.form.rate.$touch()"-->
                  <!--                  ></v-select>-->
                  <v-text-field
                      v-model="form.fio"
                      name="fio"
                      label="ФИО"
                      :error-messages="fioErrors"
                      @input="$v.form.fio.$touch()"
                      @blur="$v.form.fio.$touch()"
                  ></v-text-field>
                  <v-text-field
                      v-model="form.email"
                      name="email"
                      label="Электронная почта"
                      type="email"
                      :error-messages="emailErrors"
                      @input="$v.form.email.$touch()"
                      @blur="$v.form.email.$touch()"
                  ></v-text-field>
                  <v-text-field
                      v-model="form.phone"
                      name="phone"
                      label="Телефон"
                      :error-messages="phoneErrors"
                      @input="$v.form.phone.$touch()"
                      @blur="$v.form.phone.$touch()"
                  ></v-text-field>
                  <v-textarea
                      v-model="form.comment"
                      name="comment"
                      label="Комментарии"
                      rows="2"
                      :error-messages="commentErrors"
                      @input="$v.form.comment.$touch()"
                      @blur="$v.form.comment.$touch()"
                  ></v-textarea>
                  <v-checkbox
                      class="offer-checkbox"
                      v-model="form.offer"
                      @click="this.$v.$touch"
                      name="offer"
                  >
                    <template v-slot:label>
                      <div>
                        Принимаю условия <a  @click.stop href="/offer.html">Публичной оферты</a> и <a  @click.stop href="/policy.html">Политикой конфиденциальности</a>, даю согласие на обработку персональных данных.
                      </div>
                    </template>
                  </v-checkbox>
<!--                  <ycassa-btn btn-text="Заказать" :info="rateInfo" :email="form.email" :phone="form.phone" :fio="form.fio" :comment="form.comment"-->
<!--                              :price="ratePrice" :disabled="!form.offer || this.$v.$invalid"></ycassa-btn>-->
                      <v-btn :disabled="!form.offer" block tile color="#c42234" class="mr-4 white--text" type="submit">
                        Заказать
                      </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import ycassaBtn from "./price/ycassa"

const querystring = require("querystring");
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    ycassaBtn
  },
  data() {
    return {
      rateItems: ['Премиум (1 540 ₽)', 'Оптимальный (1 210 ₽)', 'Базовый (790 ₽)'],
      situationItems: ['Платили за ипотеку', 'Купили квартиру или дом', 'Платили за лечение', 'Платили за обучение', 'Открыли инвестиционный счет', 'Платили за страхование жизни', 'Продали недвижимость', 'Продали автомобиль', 'Иная ситуация'],
      form: {
        situation: "Платили за ипотеку",
        // rate: "Базовый (790 ₽)",
        type: "request",
        fio: "",
        email: "",
        phone: "",
        comment: "",
        offer: false
      },
    };
  },
  validations: {
    form: {
      situation: {required},
      // rate: {required},
      fio: {required},
      email: {required},
      phone: {required},
      comment: {},
      offer: {required},
    }
  },
  computed: {
    rateInfo() {
      return `Ситуация: ${this.form.situation}. ФИО: ${this.form.fio}. Email: ${this.form.email || '---'}. Телефон: ${this.form.phone}. Комментарии: ${this.form.comment || '---'}.`
    },
    ratePrice() {
      switch (this.form.rate) {
        case 'Премиум (1 540 ₽)': {
          return "1540"
        }
        case 'Оптимальный (1 210 ₽)': {
          return "1210"
        }
        case 'Базовый (790 ₽)': {
          return "790"
        }
        default: {
          return false
        }
      }
    },
    rateDescription() {
      switch (this.form.rate) {
        case 'Премиум (1 540 ₽)': {
          return "Готовим для Вас декларацию 3-НДФЛ и заявление на возврат налога, а также иные документы в зависимости от Вашей ситуации. Самостоятельно направляем документы в налоговую."
        }
        case 'Оптимальный (1 210 ₽)': {
          return "Готовим для Вас декларацию 3-НДФЛ и заявление на возврат налога, а также иные документы в зависимости от Вашей ситуации"
        }
        case 'Базовый (790 ₽)': {
          return "Готовим для Вас декларацию 3-НДФЛ и заявление на возврат налога"
        }
        default: {
          return null
        }
      }
    },
    situationErrors() {
      const errors = [];
      if (!this.$v.form.situation.$dirty) return errors;
      !this.$v.form.situation.required && errors.push("Обязательное поле.");
      return errors;
    },
    // rateErrors() {
    //   const errors = [];
    //   if (!this.$v.form.rate.$dirty) return errors;
    //   !this.$v.form.rate.required && errors.push("Обязательное поле.");
    //   return errors;
    // },
    fioErrors() {
      const errors = [];
      if (!this.$v.form.fio.$dirty) return errors;
      !this.$v.form.fio.required && errors.push("Обязательное поле.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.required && errors.push("Обязательное поле.");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.form.phone.$dirty) return errors;
      !this.$v.form.phone.required && errors.push("Обязательное поле.");
      return errors;
    },
    commentErrors() {
      const errors = [];
      if (!this.$v.form.comment.$dirty) return errors;
      return errors;
    },
    offerErrors() {
      const errors = [];
      if (!this.$v.form.offer.$dirty) return errors;
      !this.$v.form.offer.required && errors.push("Обязательное поле.");
      return errors;
    },
  },
  mounted() {
    // this.$root.$on("set-request-rate", this.setRequestRate);
    this.$root.$on("set-request-situation", this.setRequestSituation);
  },
  destroyed() {
    // this.$root.$off("set-request-rate", this.setRequestRate);
    this.$root.$off("set-request-situation", this.setRequestSituation);
  },
  methods: {
    // setRequestRate(val) {
    //   this.form.rate = val
    // },
    setRequestSituation(val) {
      this.form.situation = val
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try {
        await this.$ajax.post("https://nalog-service.site/email.php", querystring.stringify(this.form));
        this.$root.$emit('show-info', 'Спасибо за вашу заявку. Специалист свяжется с вами в ближайшее время')
        this.$refs.form.reset()
        setTimeout(() => {
          this.$v.$reset()
        }, 0)
      } catch (err) {
      }
    }
  }
};
</script>

<style lang="scss">
.form-btn {
  background-color: #c42234 !important;
  color: white !important;
}

</style>
